import type { v4 } from '@sap/ux-specification-types';
import { descriptionSrcURL, syncRule, validity } from '../../../common/decoration/decorators';
import { getSettingsPathForPage } from '../../application';

export class ObjectPageLayout implements v4.ObjectPageLayout {
    @syncRule({
        manifest: {
            path: (pageName: string[]): string => getSettingsPathForPage(pageName)
        }
    })
    @validity({
        since: '1.84.0'
    })
    @descriptionSrcURL('https://ui5.sap.com/#/topic/facfea09018d4376acaceddb7e3f03b6')
    sectionLayout?: v4.SectionLayoutType;
}
